export default __webpack_public_path__ + "mini-icon-android@2x.png";